import { FC, PropsWithChildren } from "react";

import LayoutScripts from "../LayoutScripts";
import Alerts from "@/components/common/Alerts";
import AlertDialog from "@/components/common/AlertDialogs";
import Navbar from "@/components/layout/Navbar";
import Sidebar from "@/components/layout/Sidebar";
import Footer from "@/components/layout/Footer";

const DesktopLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <LayoutScripts />
      <div className="tw:hidden tw:md:block tw:relative">
        <Alerts />
        <AlertDialog />
        <Navbar />
        <Sidebar />
        <main className="tw:h-screen tw:w-[calc(100vw-335px)] tw:max-w-[100vw-335px] tw:fixed tw:top-0 tw:left-[335px] tw:flex-1 tw:pt-[78px] tw:pb-[3.5em] tw:overflow-x-hidden tw:overflow-y-auto">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
};

export default DesktopLayout;
